// extracted by mini-css-extract-plugin
export default {"NotFound":"HUzDX5ET","popup":"ID61sLWM","logo":"IAa28Bm8","title":"UECJnVgp","info":"iFRbQUKw"};